import GoogleMap from "../utils/map";

const BranchesMap = {
  init() {
    this.render();
  },

  render() {
    const mapEl = $("#branches-map");

    if (!mapEl.length) {
      return;
    }

    const data = {
      lat: mapEl.data("lat"),
      lng: mapEl.data("lng"),
      zoom: mapEl.data("zoom"),
    };

    const locations = JSON.parse($("#branches").html());

    GoogleMap.create(data, mapEl, locations);
  },
};

export default BranchesMap;
